import OrderList from '@/pages/orderManage/orderList'

export default [
  {
    path: '/orderList',
    name: 'OrderList',
    component: OrderList,
    meta: { name: '订单列表' }
  }
]



// WEBPACK FOOTER //
// ./src/router/orderManage/OrderList.js